import {
    isFunction,
    isNumber,
    isString,
    isBoolean,
    isObject,
    isNil,
    isArray,
    isEmpty,
    isUndefined,
    isNull,
    isDate,
} from "lodash";

const isPrimitive = (v) => {
    return isNumber(v) || isString(v) || isBoolean(v);
};

export {
    isNumber,
    isString,
    isBoolean,
    isFunction,
    isPrimitive,
    isNil,
    isObject,
    isArray,
    isEmpty,
    isUndefined,
    isNull,
    isDate,
};
